export default __webpack_public_path__ + "static/media/router.59eb6c21.png";